import { Info } from 'lucide-react'
import { BackupDaysMatrixTable } from '@/components/CalendarLogicTemplates/BackupDaysMatrixTable'

/**
 * Standalone admin page to view / manage the Shipping, Rail & Truck backup-days
 * matrix. Reuses the same table the Dynamic value chooser opens.
 */
export default function AdminBackupDaysMatrix() {
  return (
    <div className="flex flex-col gap-6 p-6">
      <div>
        <h1 className="text-2xl font-semibold text-foreground">
          Shipping, Rail &amp; Truck Backup Days Matrix
        </h1>
        <p className="mt-1 text-base text-muted-foreground">
          Transit days per origin &amp; DC for each leg. A “Dynamic” rule in a
          Calendar Logic Template resolves its offset from these values.
        </p>
      </div>

      <div className="flex items-center gap-2 rounded-md border border-border bg-muted/40 px-3 py-2 text-sm text-muted-foreground">
        <Info className="h-4 w-4 shrink-0" />
        Rail and Truck are editable; Shipping is system-managed (read-only).
      </div>

      <div className="max-w-3xl">
        <BackupDaysMatrixTable scrollClassName="max-h-[calc(100vh-320px)]" />
      </div>
    </div>
  )
}
